/*
===============================================================================================================
                                 Copyright 2024-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import amplitude from 'amplitude-js';

const sendEvent = (eventName, eventProperties) => {
  amplitude.getInstance().logEvent(eventName, eventProperties);
};

const init = (apiKey) => {
  const instance = amplitude.getInstance();
  instance.init(apiKey, null, { includeReferrer: true });
};

export default {
  init,
  sendEvent,
};
